module.exports = __webpack_public_path__ + "static/media/author7.5a036f95.jpg";